import axios from 'axios'
import utils from '../../utils/utils'

let apiURL = utils.decrypt(document.querySelector("html").getAttribute("api_hermer_url"));

if (process.env.NODE_ENV === "development") {
  // alert("开发环境");
  apiURL = 'http://proxy.jiankanghao.net:50208/api/v1'
  //apiURL = 'https://hemera.haiweikexin.com/api/v1'
}

let http = axios.create({
  timeout: 12000,
  baseURL: apiURL,
  headers: {'Content-Type': 'application/json'}
});

export default http;